import { render } from "./PowerupConfig.vue?vue&type=template&id=c35bc968&scoped=true"
import script from "./PowerupConfig.vue?vue&type=script&lang=js"
export * from "./PowerupConfig.vue?vue&type=script&lang=js"

import "./PowerupConfig.vue?vue&type=style&index=0&id=c35bc968&scoped=true&lang=css"
import "./PowerupConfig.vue?vue&type=style&index=1&id=c35bc968&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35bc968"]])

export default __exports__